enum ErrorCode {
    Unknown = 'ERR_UNKNOWN',
    ApiInternal = 'ERR_API_INTERNAL',
    LibInternal = 'ERR_LIB_INTERNAL',
    UserExists = 'ERR_USER_EXISTS',
    BadArguments = 'ERR_BAD_ARGUMENTS',
    BadFile = 'ERR_BAD_FILE',
    AuthFailed = 'ERR_AUTH_FAILED',
    AccessDenied = 'ERR_ACCESS_DENIED',
    PasswordInvalid = 'ERR_PASSWORD_INVALID',
    LoadApplication = 'ERR_LOAD_APPLICATION',
    LoadDocuments = 'ERR_LOAD_DOCUMENTS',
    NoApplication = 'ERR_NO_APPLICATION',
    NoApplications = 'ERR_NO_APPLICATIONS',
    NoRelation = 'ERR_NO_RELATION',
    NoModule = 'ERR_NO_MODULE',
    NoEntity = 'ERR_NO_ENTITY',
    NoField = 'ERR_NO_FIELD',
    NoUser = 'ERR_NO_USER',
    NoPublicForm = 'ERR_NO_PUBLIC_FORM',
    NoDocument = 'ERR_NO_DOCUMENT',
    LocalStorageNotInitialized = 'ERR_LOCALSTORAGE_NOT_INITIALIZED',
    UnknownParamStorage = 'ERR_UNKNOWN_PARAM_STORAGE',
    StorageNotInitialized = 'ERR_STORAGE_NOT_INITIALIZED',
    UserIsOwner = 'ERR_USER_IS_OWNER',
    InvalidPathId = 'ERR_INVALID_PATH_ID',
    EmailInvalidSenderAddress = 'ERR_EMAIL_INVALID_SENDER_ADDRESS',
    EmailInvalidMessageEmpty = 'ERR_EMAIL_INVALID_MESSAGE_EMPTY',
    EmailPersonalDataOversize = 'ERR_EMAIL_PERSONAL_DATA_OVERSIZE',
    EmailInvalidRecipientUniq = 'ERR_EMAIL_INVALID_RECIPIENT_UNIQ',
    EmailInvalidRecipientGdpr = 'ERR_EMAIL_INVALID_RECIPIENT_GDPR',
    EmailInvalidRecipientAdrs = 'ERR_EMAIL_INVALID_RECIPIENT_ADRS',
    EmailInvalidRecipientEmpt = 'ERR_EMAIL_INVALID_RECIPIENT_EMPT',
    SmsInvalidAddressEmpty = 'ERR_SMS_INVALID_ADDRESS_EMPTY',
    BitlyRequestFailed = 'ERR_BITLY_REQUEST_FAILED',
    NotInitialized = 'ERR_NOT_INITIALIZED',
    NotImplemented = 'ERR_NOT_IMPLEMENTED',
    AlreadyExist = 'ERR_ALREADY_EXIST',
    Awaiting = 'ERR_AWAITING',
    Expired = 'ERR_EXPIRED',
    ExcelImportNoMapping = 'EXCEL_IMPORT_NO_MAPPING',
    InvalidToken = 'ERR_INVALID_TOKEN',
}

export default ErrorCode;